import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentWithContextProps } from 'lib/component-props';
import EEPlaceholder from 'components/Sections/EEPlaceholder';

type DynamicRelatedArticlesSectionProps = ComponentWithContextProps & {
  fields: {
    taxonomy: Field<string>;
  };
};

const DynamicRelatedArticlesSection = ({
  sitecoreContext,
}: DynamicRelatedArticlesSectionProps): JSX.Element => {
  const isExperienceEditor = sitecoreContext.pageEditing;

  if (isExperienceEditor) return <EEPlaceholder>Dynamic Related Articles Section</EEPlaceholder>;
  return <h1>DynamicRelatedArticlesSection COMPONENT DEPENDS ON SITECORE SEARCH</h1>;
};

export default DynamicRelatedArticlesSection;
